import { Code2 } from "lucide-react";
import { ToolsLayout } from "@/components/organisms/tools/ToolsLayout";
import { PageHeader } from "@/components/molecules/PageHeader";

export function ToolsPage() {

  return (
    <div className="flex h-full flex-col gap-4 animate-fade-in bg-background">
      <PageHeader icon={Code2} title="MCP" description="Live MCP tools, connector setup, and external service credentials in one place" />

      <div className="flex-1 min-h-0 overflow-y-auto">
        <ToolsLayout />
      </div>
    </div>
  );
}

export default ToolsPage;
